import { useState } from "react";

const BillingDatePicker = ({ installationDetails, handleInputChange }) => {
    const [selectedDate, setSelectedDate] = useState(installationDetails.customerBillingDate || "");

    // Function to ensure the selected date is between 7th and 28th
    const handleDateChange = (event) => {
        const selectedValue = event.target.value;
        const date = new Date(selectedValue);
        const day = date.getDate();

        if (day >= 7 && day <= 28) {
            setSelectedDate(selectedValue);
            handleInputChange({ target: { name: "customerBillingDate", value: selectedValue } });
        } else {
            alert("Please select a date between the 7th and 28th.");
            setSelectedDate(""); // Reset selection
        }
    };

    // Function to get min and max date dynamically for the current month
    const getMinDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-07`;
    };

    const getMaxDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-28`;
    };

    return (
        <div className="mt-4">
            <label htmlFor="customerBillingDate" className="block text-sm font-medium mb-1">
                Customer Billing Date
            </label>
            <input
                type="date"
                id="customerBillingDate"
                name="customerBillingDate"
                className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                value={selectedDate}
                onChange={handleDateChange}
                min={getMinDate()}
                max={getMaxDate()}
            />
        </div>
    );
};

export default BillingDatePicker;
